import { createFileRoute } from "@tanstack/react-router";
import { Checkbox } from "@heroui/react";
import { useAuth } from "@repo/context/auth/auth";
import { useTemplateProtectionGuidelines } from "@repo/context/template-protection-guidelines";
import { appConfig } from "@/config/app-config";

export const Route = createFileRoute("/template_protections/blacklist/rules")({
  component: RulesPage,
});

export default function RulesPage() {
  const { isAuthenticated } = useAuth();
  const { hasAgreedToGuidelines: agreed, setHasAgreedToGuidelines: setAgreed } =
    useTemplateProtectionGuidelines();

  return (
    <div className="px-4 pt-3 space-y-4">
        <p className="text-sm text-gray-500 text-center">
          兽聚汇标记机黑名单服务使用准则
        </p>
        <iframe
          src={`${appConfig.webOrigin}/terms/template-guard`}
          className="w-full h-[60vh] border-0 rounded-lg bg-white"
          title="使用准则"
        />
        <Checkbox
          isSelected={agreed}
          onChange={(checked: boolean) => setAgreed(checked)}
          isDisabled={!isAuthenticated || agreed}
        >
          <Checkbox.Content>
            <Checkbox.Control>
              <Checkbox.Indicator />
            </Checkbox.Control>
            我已阅读并同意并遵循上述使用准则（仅本浏览器有效）。
          </Checkbox.Content>
        </Checkbox>
    </div>
  );
}
